import React, { memo } from "react";

const GENDER_OPTIONS = ["Male", "Female", "Non Binary", "Prefer Not to Say"];

const GenderSelectField = ({ value = "", onChange, required = false }) => {
  return (
    <div className="half">
      <label htmlFor="gender">Gender</label>
      <select
        id="gender"
        name="gender"
        className="field"
        onChange={onChange}
        value={value}
        required={required}
        aria-label="Gender"
      >
        <option value="" disabled>Select Gender</option>
        {GENDER_OPTIONS.map((gender) => (
          <option key={gender} value={gender}>
            {gender}
          </option>
        ))}
      </select>
    </div>
  );
};

export default memo(GenderSelectField);
